import { Authority } from '@/shared/security/authority';
/* tslint:disable */
// prettier-ignore
const Task = () => import('@/task/task.vue');

// prettier-ignore
const QualityAssuranceForms = () => import('@/task/quality-assurance-forms.vue');
const SafetyForms = () => import('@/task/safety-forms.vue');
const MaintenanceReports = () => import('@/task/maintenance-forms.vue');

export default {
  path: '/task/',
  component: Task,
  children: [
    {
      path: '/task/quality-assurance-forms',
      name: 'QualityAssuranceForms',
      component: QualityAssuranceForms,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/task/safety-forms',
      name: 'SafetyForms',
      component: SafetyForms,
      meta: { authorities: [Authority.USER] },
    },
    {
      path: '/task/maintenance-reports',
      name: 'MaintenanceReports',
      component: MaintenanceReports,
      meta: { authorities: [Authority.USER] },
    },
    // jhipster-needle-add-entity-to-router - JHipster will add entities to the router here
  ],
};
